// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header .question{color:#013a60;border-bottom:4px solid #fe9800!important}.controls .default-submit{border-top:4px solid #fe9800!important}.optionStage .feedback .feedback-wrapper{width:90%}.quiz-pool{padding-top:1rem!important}", ""]);
// Exports
module.exports = exports;
